import { useTheme } from '@/components/ThemeProvider';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface IProps {
  value: string;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  clearKeyword: () => void;
}

export default (props: IProps) => {
  const { value, onInputChange, clearKeyword } = props;
  const { theme } = useTheme();
  const { t } = useTranslation();
  return (
    <div className="relative flex items-center px-[8px] w-full flex-1 h-[32px] border-[1px] border-borderColor rounded-[8px] bg-[#F4F4F5CC] dark:bg-[#27272ACC]">
      <Search />
      <Input placeholder={t('Signal.search')} value={value} className="border-none" onChange={onInputChange} />
      {value.length > 0 && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          className="size-[16px] flex-shrink-0"
          onClick={clearKeyword}
        >
          <path
            d="M8.50016 1.88477C4.82683 1.88477 1.8335 4.8781 1.8335 8.55143C1.8335 12.2248 4.82683 15.2181 8.50016 15.2181C12.1735 15.2181 15.1668 12.2248 15.1668 8.55143C15.1668 4.8781 12.1735 1.88477 8.50016 1.88477ZM10.7402 10.0848C10.9335 10.2781 10.9335 10.5981 10.7402 10.7914C10.6402 10.8914 10.5135 10.9381 10.3868 10.9381C10.2602 10.9381 10.1335 10.8914 10.0335 10.7914L8.50016 9.2581L6.96683 10.7914C6.86683 10.8914 6.74016 10.9381 6.6135 10.9381C6.48683 10.9381 6.36016 10.8914 6.26016 10.7914C6.06683 10.5981 6.06683 10.2781 6.26016 10.0848L7.7935 8.55143L6.26016 7.0181C6.06683 6.82477 6.06683 6.50477 6.26016 6.31143C6.4535 6.1181 6.7735 6.1181 6.96683 6.31143L8.50016 7.84477L10.0335 6.31143C10.2268 6.1181 10.5468 6.1181 10.7402 6.31143C10.9335 6.50477 10.9335 6.82477 10.7402 7.0181L9.20683 8.55143L10.7402 10.0848Z"
            fill={theme == 'dark' ? '#FAFAFA' : '#18181B'}
            fillOpacity="0.2"
          />
        </svg>
      )}
    </div>
  );
};
